<script lang="ts">
  import DistributorPlpRetailerUserAuthentication from "@shared/svelte/Components/ProductLines/DistributorPlpRetailerUserAuthentication.svelte";
  import { Button } from "@getprovi/craft-svelte";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import { OHLQ_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let authStatus: string;
  export let authService: any;
  export let mobileMode: boolean;
</script>

<div class="craft" data-testid="ohlq-plp-cta">
  <DistributorPlpRetailerUserAuthentication {authStatus} {mobileMode}>
    <div slot="invalid-title"> We can’t verify your Wholesale Cloud Account. </div>

    <div slot="invalid-description">
      Please call the OHLQ Liquor Enterprise Service Center at <a href="tel:+18778120013"
        >877-812-0013</a
      > then verify your account with a new API Key.
    </div>

    <svelte:fragment slot="invalid-buttons">
      <div>
        <a
          href="https://portal.ohlq.com/My-Account#/account"
          target="_blank"
          rel="noreferrer"
          class="craft-button btn-primary btn-base justify-center"
          style="border-radius: 32px;"
          on:click={() => loginEvent(authStatus, OHLQ_DISTRIBUTOR_ID)}>Log Into OHLQ</a
        >
      </div>

      <div>
        <Button
          variant="secondary"
          on:click={() => authService?.startVerification?.(authStatus)}
          label="Verify Account"
        />
      </div>
    </svelte:fragment>

    <div slot="invalid-mobile-buttons">
      <div class="fizz-flex-row fizz-justify-center fizz-stack-12">
        <a
          href="https://portal.ohlq.com/My-Account#/account"
          target="_blank"
          rel="noreferrer"
          class="craft-button btn-primary btn-base justify-center"
          style="border-radius: 32px;"
          on:click={() => loginEvent(authStatus, OHLQ_DISTRIBUTOR_ID)}>Log Into OHLQ</a
        >
      </div>

      <div class="fizz-flex-row fizz-justify-center">
        <Button
          variant="secondary"
          on:click={() => authService?.startVerification?.(authStatus)}
          label="Verify Account"
        />
      </div>
    </div>

    <div slot="pending-title"> Want to Order High Proof Spirits & Liquor? </div>

    <div slot="pending-description">
      Connect your Wholesale Cloud Account to shop from your local OHLQ agency store on Provi!
    </div>

    <div slot="pending-buttons">
      <Button size="sm" on:click={() => authService?.startVerification?.(authStatus)}
        >Connect Accounts</Button
      >
    </div>
  </DistributorPlpRetailerUserAuthentication>
</div>
